import { color } from '@stockbit/ui';
import SearchInput from 'global/Input/SearchInput';
import styled from 'styled-components';

export const ModalFollowSearchInput = styled(SearchInput)`
  height: 40px;
  background-color: ${color.snow};
  border-radius: 10px;
  border: 1px solid transparent;
  box-shadow: unset !important;

  &:hover,
  &:focus {
    border-color: transparent !important;
  }

  input {
    background-color: ${color.snow};
    &::placeholder,
    &::-webkit-input-placeholder {
      font-weight: 700;
    }
  }
`;

export const UserItemContainer = styled.div`
  margin: 40px -20px 0;
  padding: 0 20px;
  height: calc(100% - 80px);
  overflow-y: auto;
`;
